import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "minw-element-element" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_btn, {
      class: "q-my-none",
      flat: "",
      dense: "",
      round: "",
      icon: "add",
      size: "sm",
      color: "grey-8",
      onClick: () => {},
      "aria-label": _ctx.$t('add_filter')
    }, null, 8, ["aria-label"]),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.getElementName), 1)
  ], 64))
}